<template>
    <div class="container">
        <div class="common-header-wrap">
            <mt-header title="服务机构详情" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <organization-detail-header :organization_info="organization_info"></organization-detail-header>
        <mt-navbar v-model="selected">
            <mt-tab-item id="1">服务</mt-tab-item>
            <!--<mt-tab-item id="2">团队</mt-tab-item>-->
            <mt-tab-item id="3">商家</mt-tab-item>
            <mt-tab-item id="4">评价</mt-tab-item>
        </mt-navbar>
        <!-- tab-container -->
        <mt-tab-container v-model="selected">
            <mt-tab-container-item id="1">
                <organization-detail-service></organization-detail-service>
            </mt-tab-container-item>
            <mt-tab-container-item id="2">
                <organization-detail-team></organization-detail-team>
            </mt-tab-container-item>
            <mt-tab-container-item id="3">
                <organization-detail-info  :organization_info="organization_info"></organization-detail-info>
            </mt-tab-container-item>
            <mt-tab-container-item id="4">
                <organization-detail-evaluate></organization-detail-evaluate>
            </mt-tab-container-item>
        </mt-tab-container>
    </div>
</template>

<script>
import { Indicator, Toast } from 'mint-ui'
import OrganizationDetailHeader from './OrganizationDetailHeader'
import OrganizationDetailService from './OrganizationDetailService'
import OrganizationDetailInfo from './OrganizationDetailInfo'
import OrganizationDetailEvaluate from './OrganizationDetailEvaluate'
import OrganizationDetailTeam from './OrganizationDetailTeam'
import { getOrganizationInfo } from '../../../api/fuwuOrganization'

export default {
  name: 'Index',
  components: {
    OrganizationDetailHeader,
    OrganizationDetailService,
    OrganizationDetailInfo,
    OrganizationDetailEvaluate,
    OrganizationDetailTeam
  },
  data () {
    return {
      selected: '1', // 默认显示项
      organization_info: '', // 机构基本信息
      organization_id: this.$route.query.organization_id ? this.$route.query.organization_id : ''
    }
  },
  created: function () {
    this.getOrganizationInfo()
  },
  methods: {
    getOrganizationInfo () {
      Indicator.open()
      getOrganizationInfo(this.organization_id).then(res => {
        Indicator.close()
        this.organization_info = res.result.o2o_fuwu_organization_info
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    }
  }

}
</script>

<style scoped>

</style>
